import { PayloadAction } from '@reduxjs/toolkit';
import { SearchState } from '../types';

interface ToggleSearchFilterPayload {
  id: string;
  value: string | boolean;
}

// const toggleSection = (sections: SearchFiltersSection[], id: number) => {
//   if (!sections) return;

//   sections.forEach((f) => {
//     if (f.id === id) {
//       f.checked = !f.checked;
//       const newValue = f.checked;
//       f.subSections &&
//         f.subSections.forEach((sf) => {
//           sf.checked = newValue;
//         });
//     } else {
//       toggleSection(f.subSections, id);
//     }
//   });
// };

const toggleSearchFilterReducer = (state: SearchState, action: PayloadAction<ToggleSearchFilterPayload>) => {
  const targetFilterSettingValues = state.settings.filters[action.payload.id];
  if (targetFilterSettingValues) {
    const valueIndex = targetFilterSettingValues.indexOf(action.payload.value);
    if (valueIndex < 0) {
      targetFilterSettingValues.push(action.payload.value);
    } else {
      targetFilterSettingValues.splice(valueIndex, 1);
      if (!targetFilterSettingValues.length) {
        delete state.settings.filters[action.payload.id];
      }
    }
  } else {
    state.settings.filters[action.payload.id] = [action.payload.value];
  }

  const filterToUpdate = state.filters.find((f) => f.id === action.payload.id);
  if (!filterToUpdate) return;

  const facetToUpdate = filterToUpdate.facets.find((f) => f.value === action.payload.value);
  if (!facetToUpdate) return;
  facetToUpdate.checked = !facetToUpdate.checked;
  // if (!state.filters?.products) return;
  // toggleSection(state.filters?.products, action.payload);
};

export default toggleSearchFilterReducer;
